var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSensory = function SvgSensory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.652 223.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h23.586v23.586H0z",
    "data-name": "Rectangle 2871"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24.434v33.964H0z",
    "data-name": "Rectangle 2878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.968v4.756H0z",
    "data-name": "Rectangle 2885"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.664v2.319H0z",
    "data-name": "Rectangle 2886"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.679v2.152H0z",
    "data-name": "Rectangle 2887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.883v1.847H0z",
    "data-name": "Rectangle 2888"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.601v2.469H0z",
    "data-name": "Rectangle 2889"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.395v1.612H0z",
    "data-name": "Rectangle 2890"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2v3.083H0z",
    "data-name": "Rectangle 2892"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.867v2.879H0z",
    "data-name": "Rectangle 2893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.36v1.222H0z",
    "data-name": "Rectangle 2897"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sensory_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.392v16.005H0z",
    "data-name": "Rectangle 2904"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sensory_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10038"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "sensory_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.856 189.527a81.6 81.6 0 0 1-16.318-1.644 80.6 80.6 0 0 1-15.198-4.718 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377 4.563-11.341 10.982-22.675 18.564-32.774 3.967-5.284 8.198-10.152 12.577-14.47 4.607-4.542 9.382-8.478 14.193-11.697 5.09-3.406 10.26-6.036 15.367-7.816 5.415-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.384 16.889 12.652 12.652 22.266 23.309 29.392 32.58 3.542 4.607 6.481 8.872 8.988 13.039 2.423 4.03 4.38 7.866 5.983 11.73 6.247 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.3-7.742 3.134-17.116 5.271-28.657 6.533-9.037.988-19.514 1.448-32.971 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M104.627 9.083c-5.216 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.253 7.76-4.785 3.201-9.535 7.117-14.12 11.638-4.361 4.3-8.576 9.15-12.528 14.413-7.556 10.065-13.953 21.36-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.917 1.635 16.218a80 80 0 0 0 4.688 15.102 80.5 80.5 0 0 0 7.419 13.668 81 81 0 0 0 9.826 11.91 81 81 0 0 0 11.91 9.826 80.5 80.5 0 0 0 13.667 7.418 80 80 0 0 0 15.103 4.689 81 81 0 0 0 16.218 1.634c13.438 0 23.898-.459 32.917-1.445 11.494-1.257 20.824-3.383 28.524-6.5 4.255-1.723 8.051-3.783 11.282-6.123 3.416-2.473 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.422 1.976-9.393 1.976-14.773 0-3.659.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.655-5.95-11.663-2.496-4.15-5.426-8.4-8.955-12.993-7.113-9.253-16.713-19.894-29.35-32.53-11.11-11.11-23.231-16.743-36.03-16.743m0-1c12.206 0 24.704 5.002 36.737 17.035 55.474 55.474 50.38 70.136 50.38 115.128s-44.896 49.781-89.888 49.781-81.466-36.473-81.466-81.465c0-35.233 40.173-100.479 84.237-100.479"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sensory_svg__a)",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9733"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10036"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9731"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10037"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M119.907 66.302s7.239-5.341 20.315 1.938c0 0 6.766 2.572 8.317 9.159a11.9 11.9 0 0 0 2.313 4.777 14.9 14.9 0 0 1 3.3 8.175 14 14 0 0 0 1.718 5.643 17.2 17.2 0 0 1 1.878 10.086s4.184 4.513 1.831 14.571a14.3 14.3 0 0 1-2.408 11.992s1.077 7.255-5.177 9.688c0 0-3.3 7.546-13.128 8a12.7 12.7 0 0 0-4.142.92c-1.871.751-5.231 1.484-10.059.214-7.846-2.063-7.058-6.824-7.058-6.824V67.459Z",
    "data-name": "Path 15518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M115.687 66.302s-7.239-5.341-20.315 1.938c0 0-7.088 2.695-8.417 9.63a8.6 8.6 0 0 1-1.929 3.965 14.93 14.93 0 0 0-3.622 9.223 8.9 8.9 0 0 1-1.349 4.378 16.15 16.15 0 0 0-2.294 8.405 8.86 8.86 0 0 1-.947 3.857c-1.058 2.109-2.344 6.328-.794 12.95a14.4 14.4 0 0 0 1.119 9.953 11.7 11.7 0 0 1 1.265 4.325 8.55 8.55 0 0 0 3.475 6.5 12.3 12.3 0 0 1 2.9 2.819 15.22 15.22 0 0 0 11.392 6.054 18.8 18.8 0 0 1 5.023 1.077 16.13 16.13 0 0 0 9.738.091c7.846-2.063 7.058-6.824 7.058-6.824V67.459Z",
    "data-name": "Path 15519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M111.24 117.558c-3.494-.425-6.3-2.42-8.337-5.928l-.024-.042a3.58 3.58 0 0 1 1.219-4.812 3.1 3.1 0 0 0 .8-.687 16.3 16.3 0 0 1-7.78-1.24 11.7 11.7 0 0 1-4.188-3.164 7.4 7.4 0 0 0 2.313 4.233 8.1 8.1 0 0 0 3.035 1.482c1.053.231 1.5 1.275 1.887 2.268a20 20 0 0 0 1.3 2.718 15.1 15.1 0 0 0 3.232 3.967 9.36 9.36 0 0 0-4.4 3.953 8.7 8.7 0 0 0-1.068 3.02 13 13 0 0 1 2.729-3.341 8.47 8.47 0 0 1 6-2.093 14.4 14.4 0 0 0 3.281-.334",
    "data-name": "Path 15520"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M96.36 127.926q-.271 0-.543-.016a7.99 7.99 0 0 1-6.064-3.3 7.25 7.25 0 0 1-.956-7.837l.03-.064c.36-.748.56.651.517 1.478-.092 1.772 1.3 4.508 3.042 5.991 2.012 1.716 5.27 1.677 7.754 1.76.93.031 1.715.093.885.648a8.95 8.95 0 0 1-4.665 1.341",
    "data-name": "Path 15521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M91.325 137.307a1.834 1.834 0 0 1-2.409-.641 39.7 39.7 0 0 0-7-8.25 22.35 22.35 0 0 1 9.411 8.891",
    "data-name": "Path 15522"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M83.222 113.071c.706-1.345 2.561-1.845 4-2.028a20.2 20.2 0 0 1 4.108.084c-.225-.026-3.767-3.3-7.784-.75-.252-2.415-3.224-3.471-3.224-3.471a9 9 0 0 1 .9 1.609 5.8 5.8 0 0 1 .505 3.393 4.41 4.41 0 0 1-2.375 2.881s2.817.551 3.865-1.723",
    "data-name": "Path 15523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M103.932 99.689c1.456-.431 3.108.549 4.241 1.453a20.2 20.2 0 0 1 2.8 3c-.138-.18-.262-5-4.888-6.1 1.556-1.865.24-4.731.24-4.731a9 9 0 0 1-.526 1.774 5.8 5.8 0 0 1-2.081 2.728 4.41 4.41 0 0 1-3.721.306s1.569 2.4 3.93 1.57",
    "data-name": "Path 15524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M125.469 114.305c3.785-.461 6.823-2.621 9.031-6.422l.026-.046a3.88 3.88 0 0 0-1.32-5.213 3.3 3.3 0 0 1-.863-.745 17.64 17.64 0 0 0 8.428-1.343 12.66 12.66 0 0 0 4.536-3.428 8 8 0 0 1-2.505 4.586 8.75 8.75 0 0 1-3.288 1.606c-1.14.251-1.624 1.382-2.045 2.456a22 22 0 0 1-1.41 2.945 16.4 16.4 0 0 1-3.5 4.3 10.14 10.14 0 0 1 4.77 4.282 9.4 9.4 0 0 1 1.156 3.272 14.1 14.1 0 0 0-2.957-3.62 9.17 9.17 0 0 0-6.5-2.267 15.6 15.6 0 0 1-3.554-.362",
    "data-name": "Path 15525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M139.169 127.926q.271 0 .543-.016a7.99 7.99 0 0 0 6.064-3.3 7.25 7.25 0 0 0 .956-7.837l-.03-.064c-.359-.748-.561.651-.517 1.478.092 1.772-1.3 4.508-3.042 5.991-2.012 1.716-5.27 1.677-7.754 1.76-.93.031-1.715.093-.885.648a8.95 8.95 0 0 0 4.665 1.341",
    "data-name": "Path 15526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M128.102 98.348q.2-.069.393-.151a6.11 6.11 0 0 0 3.559-3.962 5.63 5.63 0 0 0-1.364-5.968l-.039-.039c-.459-.454-.238.619.011 1.212a6.8 6.8 0 0 1-.645 5.153c-1.018 1.767-3.407 2.573-5.2 3.269-.671.261-1.228.506-.475.7a6.96 6.96 0 0 0 3.759-.214",
    "data-name": "Path 15527"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M140.463 136.91a1.84 1.84 0 0 0 2.491.153 40.3 40.3 0 0 1 9.309-5.61 22.6 22.6 0 0 0-11.8 5.457",
    "data-name": "Path 15528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M142.26 87.971c-.706-1.345-2.561-1.845-4-2.028a20.2 20.2 0 0 0-4.108.084c.225-.026 3.767-3.3 7.784-.75.252-2.415 3.224-3.471 3.224-3.471a9 9 0 0 0-.905 1.614 5.8 5.8 0 0 0-.5 3.393 4.41 4.41 0 0 0 2.374 2.881s-2.817.551-3.865-1.723",
    "data-name": "Path 15529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M152.314 113.071c-.706-1.345-2.561-1.845-4-2.028a20.2 20.2 0 0 0-4.108.084c.225-.026 3.767-3.3 7.783-.75.252-2.415 3.224-3.471 3.224-3.471a9 9 0 0 0-.905 1.614 5.8 5.8 0 0 0-.505 3.393 4.42 4.42 0 0 0 2.375 2.881s-2.817.551-3.865-1.723",
    "data-name": "Path 15530"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "m116.918 146.35.186-78.894 1.765.004-.186 78.894z",
    "data-name": "Rectangle 2870"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M165.086 116.658s-.222-.5-.366-.736-.759-.93-.863-.773-.523 1.213-.3 1.509-.014.811 1.092 1.122Z",
    "data-name": "Path 15531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M177.375 113.502s-5.661 4.725-7.868 4.288a44 44 0 0 1-4.375-1.25l-.53 1.355s2.375 3.223 4.852 3.244a14.1 14.1 0 0 0 6.732-1.676Z",
    "data-name": "Path 15532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20497a",
    d: "M187.304 163.346s-.165 2.651-.677 2.689h-2.6l-3.234-.019a1.05 1.05 0 0 1 .966-.944 4.38 4.38 0 0 0 3.1-2.078c.6-1.314 2.446.347 2.446.347",
    "data-name": "Path 15533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M187.49 163.531a6.7 6.7 0 0 1-1.75.329 6.4 6.4 0 0 1-1.634-.233 45 45 0 0 0-1.2-5.733c-.534-2.067-1.3-4.724-2.381-8.027a109 109 0 0 1-3.995-14.971l-.006-.04h.01l9.221-4.049s-1.14 12.579.314 17.407a20 20 0 0 1 .528 2.313 93 93 0 0 1 .9 13.009",
    "data-name": "Path 15534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20343f",
    d: "M182.902 157.893c-.534-2.067-1.3-4.724-2.381-8.027a109 109 0 0 1-3.995-14.971v-.044l9.221-4.049s-1.14 12.579.314 17.407c.2.675-3.163 9.684-3.163 9.684",
    "data-name": "Path 15535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20497a",
    d: "M180.101 163.346s-.164 2.651-.677 2.689h-2.6l-3.234-.019a1.05 1.05 0 0 1 .966-.944 4.38 4.38 0 0 0 3.1-2.078c.6-1.314 2.446.347 2.446.347",
    "data-name": "Path 15536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M174.869 131.098a131 131 0 0 0 1.29 18.159c1.41 10.008.932 14.256.932 14.256a9.6 9.6 0 0 0 1.36.346 6.2 6.2 0 0 0 2.018-.234s2.019-10.011 1.44-15.021 2.764-17.189 2.764-17.189Z",
    "data-name": "Path 15537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m181.475 111.412-1.258 1.623-2.642.144c-.015-.213-.053-1.1-.088-1.9q.002-.071-.006-.141a67 67 0 0 1-.04-1.433l2.095-1.453.785-.6c0 .014.123.739.124.846a3.8 3.8 0 0 0 1.03 2.919",
    "data-name": "Path 15538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M174.336 131.451c.037 4.3.324 14.367.535 14.571 2.241 2.163 12.1-.593 12.62-2.976s-1.986-30.555-5.813-31.68c-.794-.233-5.04 1.14-5.04 1.14a27 27 0 0 0-1.1 3.962c-.162.822-.69 6.69-1 10.611a178 178 0 0 0-.187 2.588c-.016.263-.02.9-.012 1.784",
    "data-name": "Path 15539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fca56b",
    d: "M180.276 108.569c-.3 1-2.052 2.233-2.789 2.708q.001-.071-.006-.141c-.028-.683-.052-2.064-.052-2.064l2.107-.822c.52-.134.866-.094.74.319",
    "data-name": "Path 15540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M176.737 109.318s3.913 1.221 4.635-1.228 1.714-3.94-.753-4.823-3.231-.092-3.671.666-1.21 5-.211 5.384",
    "data-name": "Path 15541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M177.102 103.698s.25 2.849.839 2.726 1.367-.144 1.28.715.726 2.316 1.267 2.313c1.822-.011 3.829-4.913 3.33-5.8-1.439-2.558-8.8-3.075-6.716.046",
    "data-name": "Path 15542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M177.678 111.429a18 18 0 0 1 3.248-1.195c.335.111.752 1.133.752 1.133l-5.04 1.14a2.5 2.5 0 0 1 1.041-1.078",
    "data-name": "Path 15543"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m159.134 125.841 14.717 15.629a.773.773 0 0 0 1.089.011l1-.942a.773.773 0 0 0 .055-1.088l-14.745-15.658c-.284-.3-.531-.064-.846.231l-1 .942c-.315.3-.553.571-.269.874",
    "data-name": "Path 15544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m167.202 134.403 6.627 7.044a.79.79 0 0 0 1.11.034l1-.942a.79.79 0 0 0 .034-1.11l-6.627-7.044Z",
    "data-name": "Path 15545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M142.354 124.539a12.576 12.576 0 1 0 .542-17.777l-.2.19a12.574 12.574 0 0 0-.346 17.586m1.079-17.207a11.8 11.8 0 1 1-.508 16.67 11.74 11.74 0 0 1 .508-16.67",
    "data-name": "Path 15546"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9669",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9668"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__b)",
    "data-name": "Group 9667",
    transform: "translate(139.721 104.129)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#acadaf",
    d: "M3.205 19.874a11.8 11.8 0 1 0 .508-16.67 11.736 11.736 0 0 0-.508 16.67",
    "data-name": "Path 15547"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M174.336 131.45c9.352-6.333 8.59-15.043 8.59-15.043a20.88 20.88 0 0 0-8.39 10.672 178 178 0 0 0-.187 2.588c-.016.263-.02.9-.012 1.784",
    "data-name": "Path 15548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M166.093 128.246a2.4 2.4 0 0 1-1.129-.7s-.266.018.044.585c.026.048.083.169.127.256a.055.055 0 0 1-.046.079 6 6 0 0 0-1.415.03c-.1.02-.124.249-.12.347a.88.88 0 0 0 .186.6 3.1 3.1 0 0 0 1.117.585 3.4 3.4 0 0 0 1.729-.217l.566-.262-.175-1.052-.142.03c-.226.047-.505-.229-.741-.286",
    "data-name": "Path 15549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M180.182 112.506s7.944 1.513-2.337 13.017c-1.644 1.84-10.528 4.236-10.528 4.236s-.9-.767-.447-1.388c0 0 6.117-4.442 7.463-5.148.605-.318 2.35-7.089 3.337-8.72a4.45 4.45 0 0 1 2.513-2",
    "data-name": "Path 15550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M164.87 116.797a4 4 0 0 1-.311-.758 4.2 4.2 0 0 0-.513-1.16c-.054-.054-.232.016-.253.247a1.4 1.4 0 0 0 .127.5 5.7 5.7 0 0 1 .168 1c.123.4.78.171.78.171",
    "data-name": "Path 15551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed985f",
    d: "M117.549 128.182a2.106 2.106 0 0 0-3.8-.5 1.9 1.9 0 0 0-.284.957c-.051 2.014 3.921 9.81 4.448 10.5.96 1.255 6.753 4.274 6.753 4.274l1.231-.179a9 9 0 0 1-1.417-1.157c-1.489-1.486-3.659-3.9-4.056-4.237-.682-.574-1.862-6.393-2.878-9.655",
    "data-name": "Path 15552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M119.231 118.332a20 20 0 0 0-2.955 1.445c-1.333 1.479-.953 3.409-.19 3.427.489.012.394.825.394.825l5.45-2.306s-.656-3.827-2.7-3.391",
    "data-name": "Path 15553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M119.902 118.63a2.94 2.94 0 0 0-3.8-.407c-1.717 1.275-.227 3.285-2.379 3.987-1.073.35-2.823 1.118-2.168 4.191.441 2.069 6.954 4.221 6.572 5.96 0 0 2.217-3.468.585-5.165a7.8 7.8 0 0 1-1.669-3.167c.087-.329 2.86-5.4 2.86-5.4",
    "data-name": "Path 15554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m113.238 164.539-1.179-.173a13.94 13.94 0 0 1-4.556-9.032 10.5 10.5 0 0 1-.028-1.818.32.32 0 0 0-.041-.2c-.127-.195-.443-.682-.87-1.375s-1.143-1.974-1.937-3.423c-1.43-2.609-3.095-5.73-3.666-6.724-1.819-3.168-.942-5.3-.942-5.3s5.076-.5 6.467-1.719l.5.772s1.1 4.868 1.048 4.891l.165.506a85 85 0 0 1 2.411 8.754 14.5 14.5 0 0 1 .381 3.782 6.6 6.6 0 0 0 .09 1.385c.491 3.494 2.16 9.675 2.16 9.675",
    "data-name": "Path 15555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142128",
    d: "M115.712 166.031h-4.921a2.7 2.7 0 0 1 .139-1.319c.246-.546.6-.563.045-1.419a3 3 0 0 0 2.029.359 6 6 0 0 0 .853 1.3c.321.231 1.755.149 1.854 1.08",
    "data-name": "Path 15556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263c49",
    d: "M108.197 140.943c-.43 2.371-1.445 6.316-3.572 7.572-1.43-2.609-3.095-5.73-3.666-6.724-1.82-3.168-.943-5.3-.943-5.3s5.076-.5 6.467-1.719l.5.772s1.1 4.868 1.048 4.891l.165.506",
    "data-name": "Path 15557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m104.746 136.858.017-.92c-1.834.231-6.322-2.191-6.322-2.191s-1.918 1.276-2.181 4.92c-.128 1.778-.939 9.3-1.029 11.546a62 62 0 0 0-.047 1.627.32.32 0 0 1-.078.189 10.5 10.5 0 0 0-.994 1.523c-2.8 5.206-1.335 12.279-1.335 12.279l.65-.165s2.366-7.333 3.912-10.5a6.6 6.6 0 0 1 .7-1.2 14.5 14.5 0 0 0 1.8-3.348 88 88 0 0 0 3.042-9.117c.056.01 1.866-4.641 1.866-4.641",
    "data-name": "Path 15558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m118.662 125.362-.006.009a8 8 0 0 1-.19.288l-.027.04c-.156.224-.38.532-.64.838a4.3 4.3 0 0 1-1.181 1.039c-.123-.1-2.37-2-2.207-1.931a5.56 5.56 0 0 0 2.51-1.748c.38-.479 1.747 1.452 1.747 1.452",
    "data-name": "Path 15559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M117.368 127.588a15 15 0 0 1 .808 1.941c.281.9.985 3.766.985 3.766a2.3 2.3 0 1 1-4.172-1.674 15.4 15.4 0 0 1 2.379-4.033",
    "data-name": "Path 15560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed985f",
    d: "m118.661 125.363-.006.009c-.027.04-.1.144-.19.288l-.027.04c-.156.224-.38.532-.64.838a2.9 2.9 0 0 1-.971-2.8l1.84 1.614Z",
    "data-name": "Path 15561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M118.713 126.174s-2.779-1.547-1.79-3.263 1.3-3.071 3.114-2.156 1.78 1.767 1.589 2.42-2.165 3.357-2.914 3",
    "data-name": "Path 15562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M122.092 122.172c-.127-.762-.514-.835-.784-.784a2.22 2.22 0 0 0-2.7-1.035 3.8 3.8 0 0 1-2.191 1.316s.323.6 1.651.972a2.27 2.27 0 0 0 1.311-.1 7.4 7.4 0 0 1-1.886.711c1.751.16 3.417-1.441 3.59-1.612a2.5 2.5 0 0 1 .138 1.147c-.115.516-.573 1.451-.294 1.572 0 0 1.359-1.039 1.168-2.182",
    "data-name": "Path 15563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142128",
    d: "M96.69 166.032h-4.921a2.7 2.7 0 0 1 .139-1.319c.246-.546.632-.794.54-1.455a1.77 1.77 0 0 0 1.534.587 5.4 5.4 0 0 0 .854 1.107c.322.231 1.755.149 1.854 1.08",
    "data-name": "Path 15564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M115.829 134.056a12 12 0 0 1-2.431.441 16.4 16.4 0 0 0-3.33.517 4.4 4.4 0 0 0-.933.509l-.028.021a3 3 0 0 0-.386.333 2.1 2.1 0 0 0-.451.67 8.55 8.55 0 0 0 .3 3.353.87.87 0 0 1-.447.969q-.738.382-1.451.7l-.075.034c0-.1.006-.195.006-.29a9 9 0 0 0-.083-1.214 5.1 5.1 0 0 1-.968 1.948c-6.6 2.65-11.217 1.5-11.142.178a17.1 17.1 0 0 1 3.351-8.481c5.764-6.7 17.423-8.467 17.423-8.467s.558-.067 1.232.742c.969 1.166 1.017 1.47 1.017 1.47s.256 5.913-1.607 6.563",
    "data-name": "Path 15565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M113.398 134.497a16.4 16.4 0 0 0-3.33.517 13.65 13.65 0 0 1 1.731-7.488s1.316 5.354 1.6 6.971",
    "data-name": "Path 15566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M108.571 139.9a.87.87 0 0 1-.447.969q-.738.382-1.45.7a4 4 0 0 1-.069-.256 4.5 4.5 0 0 1-.083-1.215 6.6 6.6 0 0 1 2.2-4.225 2.1 2.1 0 0 0-.451.67 8.5 8.5 0 0 0 .3 3.353",
    "data-name": "Path 15567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6980e0",
    d: "M115.186 125.28s.508-.642.851-.621c0 0 1.388 1.943 1.4 2.834 0 0-1.731-2.3-2.25-2.213",
    "data-name": "Path 15568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed985f",
    d: "M128.498 144.077s-.738.013-.9-.01a5 5 0 0 0-.575-.1 2.5 2.5 0 0 0-.59.1.4.4 0 0 1-.088.008h-1.224a.73.73 0 0 1-.257-.275c-.058-.094-.066-.316-.2-.39-.741-.413 1.231-.179 1.231-.179a7.6 7.6 0 0 1 1.352.063 14 14 0 0 1 1.246.781",
    "data-name": "Path 15569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed985f",
    d: "M125.124 144.078a5.7 5.7 0 0 1 .955.356l.216.136s.125-.139-.072-.294a.95.95 0 0 1-.4-.594c-.009-.274-.857-.035-.7.4",
    "data-name": "Path 15570"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M136.8 164.92a3.2 3.2 0 0 1-3.2-3.2v-20.229h6.406v20.229a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Path 15571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d14842",
    d: "M136.8 163.991a2.38 2.38 0 0 1-2.38-2.38v-7.2h4.76v7.2a2.38 2.38 0 0 1-2.38 2.38",
    "data-name": "Path 15572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M146.363 164.92a3.2 3.2 0 0 1-3.2-3.2v-20.229h6.406v20.229a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Path 15573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d14842",
    d: "M146.364 163.992a2.38 2.38 0 0 1-2.38-2.38v-9.192h4.76v9.192a2.38 2.38 0 0 1-2.38 2.38",
    "data-name": "Path 15574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M122.451 150.016a3.2 3.2 0 0 1-1.706-4.2l7.866-18.637 5.9 2.491-7.865 18.637a3.2 3.2 0 0 1-4.2 1.706",
    "data-name": "Path 15575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m123.038 149.254-.452-.19a2.135 2.135 0 0 1-1.137-2.8l5.675-13.446 5.114.123-6.4 15.173a2.135 2.135 0 0 1-2.8 1.137",
    "data-name": "Path 15576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M121.849 146.28a3 3 0 0 0 .945.578c.408.1.872 1.27.947 1.437s-.39-.074-.575-.359-.312-.4-.367-.334a2.18 2.18 0 0 0 .342 1.275c.309.433.495.817.272.792s-1.547-.346-1.819-1.151-.073-.832-.7-1.66.953-.578.953-.578",
    "data-name": "Path 15577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M114.756 126.699s-3.243.32-3.5 2.427 3.109 10.689 3.591 11.467c.878 1.415 6.051 6.264 6.051 6.264l.953-.578s-3.669-6.211-4.237-6.792c-.892-.912-1.758-12.059-2.856-12.789",
    "data-name": "Path 15578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M116.419 130.724s.333-5.433-3.825-4.119.645 10.658.645 10.658a3.95 3.95 0 0 0 3.306-2.25Z",
    "data-name": "Path 15579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M123.154 162.157h29.071v1.047h-29.071z",
    "data-name": "Rectangle 2872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M123.154 162.946h1.361v3.364h-1.361z",
    "data-name": "Rectangle 2873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b98a0",
    d: "M150.674 162.157h1.551v4.153h-1.551z",
    "data-name": "Rectangle 2874"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M139.929 141.69h-6.424a.284.284 0 1 1 0-.568h6.424a.284.284 0 0 1 0 .568",
    "data-name": "Path 15580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "M149.575 141.69h-6.424a.284.284 0 0 1 0-.568h6.424a.284.284 0 1 1 0 .568",
    "data-name": "Path 15581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a9b3b7",
    d: "m134.389 129.797-6.036-2.2a.284.284 0 0 1 .194-.534l6.037 2.2a.284.284 0 0 1-.195.534",
    "data-name": "Path 15582"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4a36c",
    d: "M70.263 165.647c-.071.191-5.775.406-5.8-.2v-.082a2 2 0 0 1 .013-.187c.016-.119.042-.236.068-.353a4 4 0 0 1 .179-.512 2.1 2.1 0 0 0 .194-.81c-.041-.83-.34-2.577-.34-2.577l1.641-.183a14.5 14.5 0 0 0 .571 2.951 3.12 3.12 0 0 0 1.939 1.358l.262.074c.691.19 1.338.353 1.274.523",
    "data-name": "Path 15583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f323d",
    d: "M70.319 165.654c-.071.191-.606.617-1.956.559s-1.087-.3-2.056-.212-1.818.052-1.845-.552v-.031c0-.058.005-.142.014-.238.016-.118.042-.236.068-.353a4 4 0 0 1 .179-.512c.612.162 1.424.888 2.271 1a4.6 4.6 0 0 0 1.986-.174l.009-.012c.823.149 1.394.36 1.33.53",
    "data-name": "Path 15584"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M71.094 140.749a.93.93 0 0 1-.931-.931v-5.879h1.862v5.879a.93.93 0 0 1-.931.931",
    "data-name": "Path 15585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M71.094 140.479a.69.69 0 0 1-.692-.692v-2.091h1.383v2.091a.69.69 0 0 1-.692.692",
    "data-name": "Path 15586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M73.869 140.749a.93.93 0 0 1-.931-.931v-5.879H74.8v5.879a.93.93 0 0 1-.931.931",
    "data-name": "Path 15587"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M73.874 140.479a.69.69 0 0 1-.692-.692v-2.668h1.383v2.672a.69.69 0 0 1-.692.692",
    "data-name": "Path 15588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M68.579 140.749a.93.93 0 0 1-.931-.931v-5.879h1.862v5.879a.93.93 0 0 1-.931.931",
    "data-name": "Path 15589"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M68.579 140.479a.69.69 0 0 1-.692-.692v-2.668h1.383v2.672a.69.69 0 0 1-.692.692",
    "data-name": "Path 15590"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M66.488 139.769h.524v1.555h-.524z",
    "data-name": "Rectangle 2875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M75.441 139.769h.523v1.555h-.523z",
    "data-name": "Rectangle 2876"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M66.488 139.769h9.477v.454h-9.477z",
    "data-name": "Rectangle 2877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M54.223 120.099a3.07 3.07 0 0 0-2.179-.207c-2.33.716-1.207 2.63-2.388 3.4s-2.26 3.113-1.515 4.313 1.835 2.224 2.5 1.4a5.5 5.5 0 0 0 1.331-3.505c.005-1.4.568-4.247 1.531-4.029s.723-1.375.723-1.375",
    "data-name": "Path 15591"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M57.675 122.167s-1.124-2.51-3.452-2.067-2.648 4.807-1.114 5.37c1.067.391 4.566-3.3 4.566-3.3",
    "data-name": "Path 15592"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9672",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9671"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__c)",
    "data-name": "Group 9670",
    transform: "translate(39.982 132.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M23.883 16.461h-6.395L13.605 3.037A4.04 4.04 0 0 0 9.813.118L3.089.001A2.9 2.9 0 0 0 .05 3.355l1.805 30.211a.37.37 0 0 0 .376.4h.027a.24.24 0 0 0 .249-.2l.266-14.911h11.5l2.132 14.911a.24.24 0 0 0 .249.2h.027a.37.37 0 0 0 .376-.4l-1.473-14.714h8.3a.553.553 0 0 0 .552-.551v-1.288a.553.553 0 0 0-.552-.552",
    "data-name": "Path 15593"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#abddda",
    d: "m50.179 135.292 2.151 5.443s2.073 2.443 3.739 1.655l-5.271-10.236Z",
    "data-name": "Path 15594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f323d",
    d: "M66.061 146.286c-1.562-1.553-11.266-5.657-14.542-6.008l-3.745-1.369a22 22 0 0 0-1.551 7.148c-.011 1.629 2 2.7.478 2.7 0 0 13.254-.052 13.763 0 .833.086.364 2.049.639 3.939s3.742 9.827 3.742 9.827a6 6 0 0 0 1.476.3 1.5 1.5 0 0 0 .734-.2s.9-14.451-1-16.336",
    "data-name": "Path 15595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M61.699 165.635c.027.6 5.73.389 5.8.2.063-.17-.583-.333-1.275-.523l-.261-.073a3.12 3.12 0 0 1-1.938-1.358 14.6 14.6 0 0 1-.571-2.951l-1.641.182s.3 1.747.341 2.577a5.3 5.3 0 0 1-.373 1.323 2.4 2.4 0 0 0-.082.625",
    "data-name": "Path 15596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f323d",
    d: "M63.544 166.187c.969-.083.7.153 2.055.212s1.885-.367 1.956-.559c.063-.17-.507-.381-1.33-.53l-.009.012a3.8 3.8 0 0 1-1.993.3c-.9-.117-1.819-.523-2.443-.609a2.4 2.4 0 0 0-.082.625c.027.6.877.636 1.845.552",
    "data-name": "Path 15597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M63.774 146.307c-.918-.959-7-2.926-10.083-3.93-.743-.242-7.963-3.82-7.963-3.82s-1.141 10.2.236 10.214c2.58.026 12.568.48 12.959.508 1.183.085.561 2.822 1.029 4.992.479 2.22 1.863 8.253 1.863 8.253a6 6 0 0 0 1.476.3 1.5 1.5 0 0 0 .734-.2s1.6-14.382-.253-16.315",
    "data-name": "Path 15598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M55.353 125.935s-.059.412-.152.923c-.056.306-.124.648-.2.957a5 5 0 0 1-.2.659c-.246.609-.439 1.2-.326 1.323a3.3 3.3 0 0 1-2.01-.406 3.64 3.64 0 0 1-.948-1.888c.367-.067.8-.148 1.549-2.053l.134.086Z",
    "data-name": "Path 15599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M55.202 126.858c-.056.306-.124.648-.2.957a4.35 4.35 0 0 1-1.918-2.191Z",
    "data-name": "Path 15600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M55.788 127.167s-3.2-.538-2.834-2.526.2-3.4 2.258-3.136 2.315 1.091 2.354 1.784-.936 3.967-1.777 3.878",
    "data-name": "Path 15601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M57.485 122.19s-2.117 1.7-3.521 1.8-1.54-.552-1.54-.552a6.4 6.4 0 0 0 1-1.564.99.99 0 0 1 .831-.553c1-.053 2.9-.03 3.229.868",
    "data-name": "Path 15602"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M56.204 121.989a5 5 0 0 1 .867 1.189 3.9 3.9 0 0 1 .037 2.072s1.142-2.05.568-3.083a.857.857 0 0 0-1.471-.178",
    "data-name": "Path 15603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M56.822 131.038c0-1.344-2-2.61-2-2.61s-.486 1.334-2.846-1.117c-.084-.087-5.57 3.538-5.57 3.538s-.92 4.7-1.122 6.848a53 53 0 0 0 .159 11.582s7.92 1.41 13.15-6.792c0 0-1.849-4.232-1.849-5.411 0-.761.076-5.437.078-6.039",
    "data-name": "Path 15604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M46.223 139.17s2.237 2.988 8.681 2.465l-3-2.842Z",
    "data-name": "Path 15605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m54.318 138.349-.729.941a37 37 0 0 1-3.778-1.448c-1.574-.621-.833-4.547-.334-3.218.664 1.77 2.874 2.726 4.841 3.724",
    "data-name": "Path 15606"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m57.578 128.263 2.027-.933 3.389 7.362-2.027.933z",
    "data-name": "Rectangle 2879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m57.679 126.891.97-.446 1.62 3.518-.969.447z",
    "data-name": "Rectangle 2880"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m53.851 140.151 1.771-.273a15 15 0 0 1 .363-5.929 5.08 5.08 0 0 1 3.828-3.078l-.271-1.772c-.165.025-4.054.66-5.258 4.284a16.6 16.6 0 0 0-.434 6.768",
    "data-name": "Path 15607"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M51.073 141.445h7.663v-.434a1.6 1.6 0 0 0-1.6-1.6h-4.135a1.93 1.93 0 0 0-1.93 1.93Z",
    "data-name": "Path 15608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M54.904 137.076h8.292v.597h-8.292z",
    "data-name": "Rectangle 2881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M57.446 140.428h5.75v1.019h-5.75z",
    "data-name": "Rectangle 2882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M59.686 140.014h1.817v.415h-1.817z",
    "data-name": "Rectangle 2883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M57.51 139.65a4 4 0 0 0 .59.641.44.44 0 0 0 .24.051l-.3-.539Z",
    "data-name": "Path 15609"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m57.407 139.06 1.291.627a.23.23 0 0 1-.214.083 3 3 0 0 1-.56-.154Z",
    "data-name": "Path 15610"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M54.946 139.344a9 9 0 0 1 2.461-.284 5 5 0 0 1 1.282 1.111c.1.238-.761-.181-1.043-.256a2.5 2.5 0 0 0-.9.2 3 3 0 0 1-1.613.162Z",
    "data-name": "Path 15611"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M47.939 141.312h30.015v.847H47.939z",
    "data-name": "Rectangle 2884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M77.823 166.708c-.062-.088-.191-.272-1-12.571-.4-6.058-.771-12.148-.775-12.209l.317-.019c.4 6.639 1.5 24.006 1.731 24.639l-.012-.022Z",
    "data-name": "Path 15612"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m47.681 166.577-.26-.183-.012.021c.227-.63 1.367-17.9 1.787-24.505l.317.02c0 .06-.389 6.117-.8 12.142-.839 12.233-.968 12.416-1.03 12.5",
    "data-name": "Path 15613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M51.977 127.311s-3.235 0-4.307 1.074c-1.682 1.683-2.966 9.046-1.738 10.525 1.383 1.665 9.247 1.752 9.247 1.752s.189-.343-.232-1.317c-.088-.2-5.135-2.234-5.289-2.5a22 22 0 0 1-.116-4.695c.174-.634 2.436-4.836 2.436-4.836",
    "data-name": "Path 15614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M132.074 79.041a.46.46 0 0 1 .082.494 3.1 3.1 0 0 1-.969 1.064q-.088.07-.156.13l-.035.031-.027.024c-.426.393-.266.483-1.031 1.28-.873.908-1.474.925-1.645.842-.145-.071.149-.552.475-1.094l.047-.079.13-.217c.382-.652.284-.957.193-1.927-.074-.788-1.226-4.4-1.226-4.4l1.673-.288s.5 2.878 1.059 3.322c.3.236.629.239.914.414l.059.037a2.2 2.2 0 0 1 .458.368",
    "data-name": "Path 15615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M132.073 79.039a.46.46 0 0 1 .082.494 3.6 3.6 0 0 1-.971 1.06 4 4 0 0 0-.154.133l-.035.031-.027.024c-.426.393-.266.483-1.031 1.28-.873.908-1.474.925-1.645.842-.145-.071.149-.552.475-1.094a3.7 3.7 0 0 0 1.556-1.147c.506-.646.851-1.47 1.2-1.976l.1-.018a2.2 2.2 0 0 1 .458.368",
    "data-name": "Path 15616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M118.583 77.995c-.1.516-.84.43-1.662.229s-.627.038-1.8-.092-1.525-.566-1.561-.74c-.032-.154.546-.209 1.167-.28l.235-.028a5.1 5.1 0 0 0 1.85-.911 7.4 7.4 0 0 0 1.5-1.784l1.605.127s-.842 1.279-1.168 1.836a1.94 1.94 0 0 0-.158 1.094 2 2 0 0 1-.012.549",
    "data-name": "Path 15617"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M116.921 78.221c-.822-.2-.627.038-1.8-.092s-1.525-.566-1.561-.74c-.032-.154.547-.209 1.167-.28l.006.012a3.3 3.3 0 0 0 1.676.521c.794.019 1.635-.208 2.184-.2a2 2 0 0 1-.012.549c-.1.516-.839.43-1.662.229",
    "data-name": "Path 15618"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3552",
    d: "m124.735 67.731 1.5 4.038 1.959 5.272a3.2 3.2 0 0 0 1.041-.1 4.5 4.5 0 0 0 1.006-.49 57 57 0 0 0-1.559-8.911 5.8 5.8 0 0 0-.873-1.889c-1.573-1.859-3.075 2.074-3.075 2.074",
    "data-name": "Path 15619"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M126.261 61.318c.854-.276 3.083 0 5.5.433a1.64 1.64 0 0 0 1.693-.765l6.084-.475s2.424 4.818.616 7.265c-1.056 1.43-4.615 1.225-5.693 1a43 43 0 0 1-6.77-2.456c-.715-.143-1 1.287-1.716 2.789s-6.723 6.651-6.723 6.651a5.3 5.3 0 0 1-1.3-.134 1.3 1.3 0 0 1-.56-.354s6.657-13.244 8.874-13.959",
    "data-name": "Path 15620"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M141.067 64.7a11.4 11.4 0 0 1-.928 5.1 11.5 11.5 0 0 1-9.566-8.254 2.82 2.82 0 0 0 2.292-1.036l6.593-4.206.4-.256.413-.263s.123.666.274 1.74a55 55 0 0 1 .508 5.842q.02.663.015 1.331",
    "data-name": "Path 15621"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152949",
    d: "M133.49 52.609c2.167 1.193 6.562 3.666 6.584 3.65 0 0 1.615.609 2.532 0 1.527-1.014 2.347-3.745-.447-6.094-1.393-1.172-2.383-1.457-2.533-3.328-.082-1.019-1.48-4.392-3.8-4.051a3 3 0 0 1-.561.034 2.16 2.16 0 0 0-1.162.3c-1.3.777-3.859 9.025-.611 9.487",
    "data-name": "Path 15622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M135.305 51.594a2.86 2.86 0 0 0 1.785.055 3.2 3.2 0 0 0 1.179-1.413c-.308-.014-.659-.506-.906-2.049l-.131.047-2.2.793s.16.707.263 1.38c.087.565.134 1.107.013 1.187",
    "data-name": "Path 15623"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M135.029 49.027s.088.381.216 1.094a2.49 2.49 0 0 0 1.987-1.887Z",
    "data-name": "Path 15624"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M134.701 49.728s3.014-.4 2.734-2.278-.081-3.187-2.018-3.008-2.2.95-2.261 1.6.753 3.745 1.545 3.688",
    "data-name": "Path 15625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152949",
    d: "M133.266 45.013s1.93 1.663 3.242 1.8a2.52 2.52 0 0 0 1.81-.287 5.1 5.1 0 0 1-1.239-1.679.92.92 0 0 0-.761-.544c-.937-.081-2.714-.118-3.052.713",
    "data-name": "Path 15626"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152949",
    d: "M134.473 44.864a4.8 4.8 0 0 0-.849 1.087 3.65 3.65 0 0 0-.1 1.94s-1.006-1.956-.436-2.906a.8.8 0 0 1 1.384-.121",
    "data-name": "Path 15627"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M132.772 56.03c.091 6.1.025 4.827.692 5.406a2.56 2.56 0 0 0 1.208.262c1.871.124 5.16-.184 5.286-.53.432-1.2.127-1.568.487-3.4q.057-.292.139-.635c.3-1.258.592-1.686-.473-3.707a16.5 16.5 0 0 0-2.041-3.276c-2.548 1.513-2.773.254-2.773.254s-2.57 2.65-2.525 5.627",
    "data-name": "Path 15628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m126.235 71.769 1.959 5.272a3.2 3.2 0 0 0 1.041-.1 4.5 4.5 0 0 0 1.006-.49 57 57 0 0 0-1.559-8.911Z",
    "data-name": "Path 15629"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M135.292 50.407s-2.312.339-2.642 1.614c-.293 1.133-1.343 7.554-1.343 7.554s.473 1.111 1.089.495 1.938-6.412 1.938-6.412Z",
    "data-name": "Path 15630"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M134.578 60.775a3.6 3.6 0 0 1-.514.558.4.4 0 0 1-.209.045l.261-.469Z",
    "data-name": "Path 15631"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m134.669 60.265-1.125.546a.2.2 0 0 0 .186.072 2.7 2.7 0 0 0 .488-.134Z",
    "data-name": "Path 15632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M141.053 63.37c-1.74-.138-6.128-1.617-5.378-2.66.347-.483 2.671-.7 3.871-2.228.323-.413-.041-1.538-.088-2.175-.02-.275-.006-.474.088-.519s.2.074.312.263a9.5 9.5 0 0 1 .628 1.491l.058-.014a55 55 0 0 1 .508 5.842",
    "data-name": "Path 15633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M136.812 60.512a7.9 7.9 0 0 0-2.144-.247 4.3 4.3 0 0 0-1.117.968c-.091.208.663-.158.908-.223a2.2 2.2 0 0 1 .784.172 2.6 2.6 0 0 0 1.405.141Z",
    "data-name": "Path 15634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M138.065 50.153s2.461.164 3.32 1.361c1.208 1.685 2.5 8.889 1.131 9.847-1.547 1.078-5.939.258-5.939.258s-.411-1.221.072-1.268c1.308-.125 3.866-.669 3.842-1.24-.036-.868-1.648-3.75-1.648-4.322s-.777-4.635-.777-4.635",
    "data-name": "Path 15635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M125.065 61.55h11.747v.259h-11.643Z",
    "data-name": "Path 15636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M134.065 61.809h-8.9l-2.676-6.655h8.882Z",
    "data-name": "Path 15637"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.414 58.48a.308.308 0 0 1 .3-.423.61.61 0 0 1 .545.423.308.308 0 0 1-.3.424.61.61 0 0 1-.545-.424",
    "data-name": "Path 15638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M104.211 92.773H62.283a3.96 3.96 0 0 1-3.96-3.96V63.354a3.96 3.96 0 0 1 3.96-3.96h41.929a3.96 3.96 0 0 1 3.96 3.96v25.459a3.96 3.96 0 0 1-3.96 3.96",
    "data-name": "Path 15639"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M71.549 63.022s1.448-1.083 4.064.393a2.89 2.89 0 0 1 1.664 1.858 2.4 2.4 0 0 0 .463.969 3.05 3.05 0 0 1 .66 1.658 2.9 2.9 0 0 0 .344 1.145 3.53 3.53 0 0 1 .375 2.046 3.33 3.33 0 0 1 .366 2.956 2.93 2.93 0 0 1-.482 2.433 1.86 1.86 0 0 1-1.036 1.965 3 3 0 0 1-2.626 1.624 2.5 2.5 0 0 0-.828.187 3.13 3.13 0 0 1-2.012.043c-1.57-.419-1.412-1.384-1.412-1.384V63.253Z",
    "data-name": "Path 15640"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M70.704 63.022s-1.448-1.083-4.064.393a2.86 2.86 0 0 0-1.684 1.954 1.75 1.75 0 0 1-.386.8 3.05 3.05 0 0 0-.724 1.871 1.8 1.8 0 0 1-.27.888 3.3 3.3 0 0 0-.459 1.705 1.8 1.8 0 0 1-.189.782 3.88 3.88 0 0 0-.159 2.627 2.96 2.96 0 0 0 .224 2.019 2.4 2.4 0 0 1 .253.877 1.74 1.74 0 0 0 .7 1.318 2.5 2.5 0 0 1 .581.572 3.04 3.04 0 0 0 2.279 1.228 3.7 3.7 0 0 1 1 .219 3.2 3.2 0 0 0 1.948.018c1.569-.419 1.412-1.384 1.412-1.384V63.253Z",
    "data-name": "Path 15641"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9675",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9674"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__d)",
    "data-name": "Group 9673",
    transform: "translate(65.611 69.267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M3.968 3.488a2.39 2.39 0 0 1-1.807-1.3l-.005-.009a.794.794 0 0 1 .264-1.057.7.7 0 0 0 .173-.151A3.5 3.5 0 0 1 .907.698 2.54 2.54 0 0 1 0-.002a1.63 1.63 0 0 0 .5.93 1.7 1.7 0 0 0 .658.326c.228.051.325.28.409.5a4.5 4.5 0 0 0 .282.6 3.3 3.3 0 0 0 .7.872 2.04 2.04 0 0 0-.954.869 1.9 1.9 0 0 0-.231.664 2.9 2.9 0 0 1 .591-.734 1.82 1.82 0 0 1 1.3-.46 3 3 0 0 0 .711-.073",
    "data-name": "Path 15642"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9678",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9677"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__e)",
    "data-name": "Group 9676",
    transform: "translate(65.178 73.199)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.661 2.319h-.109a1.6 1.6 0 0 1-1.213-.67A1.49 1.49 0 0 1 .148.059L.154.046c.072-.152.112.132.1.3a1.8 1.8 0 0 0 .609 1.215 2.52 2.52 0 0 0 1.551.357c.186.006.343.019.177.132a1.77 1.77 0 0 1-.933.272",
    "data-name": "Path 15643"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9681",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9680"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__f)",
    "data-name": "Group 9679",
    transform: "translate(68.197 67.443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "m.855 2.075-.078-.031a1.23 1.23 0 0 1-.712-.8A1.15 1.15 0 0 1 .338.033L.346.025c.092-.092.048.126 0 .246a1.4 1.4 0 0 0 .129 1.045 1.95 1.95 0 0 0 1.04.663c.134.053.246.1.1.142a1.37 1.37 0 0 1-.752-.043",
    "data-name": "Path 15644"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9684",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9683"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__g)",
    "data-name": "Group 9682",
    transform: "translate(63.949 75.618)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.883 1.804a.364.364 0 0 1-.482-.13A8 8 0 0 0 .001 0a4.5 4.5 0 0 1 1.883 1.8",
    "data-name": "Path 15645"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9687",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9686"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__h)",
    "data-name": "Group 9685",
    transform: "translate(68.533 74.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.313 1.658a1.03 1.03 0 0 1-.308-.845A4 4 0 0 1 1.125 0a1.355 1.355 0 0 0-.346 1.526C.286 1.515 0 2.078 0 2.078a2 2 0 0 1 .347-.139 1.2 1.2 0 0 1 .7-.014.9.9 0 0 1 .52.544.71.71 0 0 0-.25-.811",
    "data-name": "Path 15646"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9690",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9689"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__i)",
    "data-name": "Group 9688",
    transform: "translate(65.447 66.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M.775 1.251a1.03 1.03 0 0 1 .8-.411 4 4 0 0 1 .822.017A1.355 1.355 0 0 0 .84.705C.79.215.195.005.195.005a2 2 0 0 1 .181.327 1.2 1.2 0 0 1 .1.688.9.9 0 0 1-.475.584.71.71 0 0 0 .773-.35",
    "data-name": "Path 15647"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9693",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9692"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__i)",
    "data-name": "Group 9691",
    transform: "translate(63.437 71.254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M.773 1.251a1.03 1.03 0 0 1 .8-.411 4 4 0 0 1 .822.017A1.36 1.36 0 0 0 .838.705c-.05-.49-.645-.7-.645-.7a2 2 0 0 1 .181.327 1.2 1.2 0 0 1 .1.688.9.9 0 0 1-.475.584.71.71 0 0 0 .773-.35",
    "data-name": "Path 15648"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9696",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9695"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__j)",
    "data-name": "Group 9694",
    transform: "translate(68.334 63.252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M.359 2.071a1.28 1.28 0 0 0 .385-1.055A5 5 0 0 0 .595.001a1.69 1.69 0 0 1 .432 1.905c.615-.014.973.689.973.689a2.3 2.3 0 0 0-.434-.173 1.5 1.5 0 0 0-.869-.018 1.12 1.12 0 0 0-.65.68.89.89 0 0 1 .312-1.013",
    "data-name": "Path 15649"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9699",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9698"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__k)",
    "data-name": "Group 9697",
    transform: "translate(66.376 76.419)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M.335 1.928A1.2 1.2 0 0 0 .694.943a4.6 4.6 0 0 0-.139-.948 1.58 1.58 0 0 1 .4 1.779c.574-.013.908.643.908.643a2 2 0 0 0-.405-.162 1.4 1.4 0 0 0-.811-.017 1.04 1.04 0 0 0-.607.635.83.83 0 0 1 .292-.945",
    "data-name": "Path 15650"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9702",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9701"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__d)",
    "data-name": "Group 9700",
    transform: "translate(72.662 69.267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M0 3.488a2.39 2.39 0 0 0 1.807-1.3l.005-.009a.793.793 0 0 0-.264-1.057.7.7 0 0 1-.173-.151A3.5 3.5 0 0 0 3.061.698a2.54 2.54 0 0 0 .907-.7 1.63 1.63 0 0 1-.5.93 1.7 1.7 0 0 1-.658.326c-.228.051-.325.28-.409.5a4.5 4.5 0 0 1-.282.6 3.3 3.3 0 0 1-.7.872 2.04 2.04 0 0 1 .954.869 1.9 1.9 0 0 1 .231.664 2.9 2.9 0 0 0-.591-.734 1.82 1.82 0 0 0-1.3-.46 3 3 0 0 1-.711-.073",
    "data-name": "Path 15651"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9705",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9704"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__e)",
    "data-name": "Group 9703",
    transform: "translate(74.399 73.199)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.003 2.319h.109a1.6 1.6 0 0 0 1.213-.67 1.49 1.49 0 0 0 .191-1.59L2.51.046c-.072-.152-.112.132-.1.3a1.8 1.8 0 0 1-.609 1.215 2.52 2.52 0 0 1-1.551.357c-.186.006-.343.019-.177.132a1.77 1.77 0 0 0 .933.272",
    "data-name": "Path 15652"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9708",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9707"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__f)",
    "data-name": "Group 9706",
    transform: "translate(72.364 67.443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "m.825 2.075.079-.031a1.23 1.23 0 0 0 .712-.8A1.15 1.15 0 0 0 1.343.033L1.335.025c-.092-.092-.048.126 0 .246a1.4 1.4 0 0 1-.129 1.045 1.95 1.95 0 0 1-1.04.663c-.134.053-.246.1-.1.142a1.37 1.37 0 0 0 .752-.043",
    "data-name": "Path 15653"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9711",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9710"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__l)",
    "data-name": "Group 9709",
    transform: "translate(76.197 75.727)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M0 1.107a.364.364 0 0 0 .5.031A8 8 0 0 1 2.362 0a4.5 4.5 0 0 0-2.36 1.107",
    "data-name": "Path 15654"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9714",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9713"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__h)",
    "data-name": "Group 9712",
    transform: "translate(72.107 74.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M.288 1.658A1.03 1.03 0 0 0 .596.813 4 4 0 0 0 .476 0a1.355 1.355 0 0 1 .346 1.526c.492-.011.779.552.779.552a2 2 0 0 0-.347-.139 1.2 1.2 0 0 0-.7-.014.9.9 0 0 0-.521.544.71.71 0 0 1 .25-.811",
    "data-name": "Path 15655"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9717",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9716"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__i)",
    "data-name": "Group 9715",
    transform: "translate(74.399 66.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.622 1.251a1.03 1.03 0 0 0-.8-.411A4 4 0 0 0 0 .857 1.355 1.355 0 0 1 1.557.705c.05-.49.645-.7.645-.7a2 2 0 0 0-.181.327 1.2 1.2 0 0 0-.1.688.9.9 0 0 0 .475.584.71.71 0 0 1-.773-.35",
    "data-name": "Path 15656"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9720",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9719"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__i)",
    "data-name": "Group 9718",
    transform: "translate(76.409 71.254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.626 1.251a1.03 1.03 0 0 0-.8-.411 4 4 0 0 0-.822.017A1.355 1.355 0 0 1 1.561.705c.051-.49.645-.7.645-.7a2 2 0 0 0-.181.327 1.2 1.2 0 0 0-.1.688.9.9 0 0 0 .475.584.71.71 0 0 1-.773-.35",
    "data-name": "Path 15657"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9723",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9722"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__j)",
    "data-name": "Group 9721",
    transform: "translate(71.908 63.252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.64 2.071a1.28 1.28 0 0 1-.385-1.055A5 5 0 0 1 1.404.001a1.69 1.69 0 0 0-.432 1.905c-.615-.014-.973.689-.973.689a2.3 2.3 0 0 1 .434-.173 1.5 1.5 0 0 1 .869-.018 1.12 1.12 0 0 1 .65.68.89.89 0 0 0-.312-1.013",
    "data-name": "Path 15658"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9726",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9725"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__k)",
    "data-name": "Group 9724",
    transform: "translate(73.998 76.419)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M1.531 1.928a1.2 1.2 0 0 1-.359-.985 4.7 4.7 0 0 1 .139-.948 1.58 1.58 0 0 0-.4 1.779c-.574-.013-.908.643-.908.643a2 2 0 0 1 .405-.162 1.4 1.4 0 0 1 .811-.017 1.04 1.04 0 0 1 .607.635.83.83 0 0 0-.292-.945",
    "data-name": "Path 15659"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9729",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9728"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sensory_svg__m)",
    "data-name": "Group 9727",
    transform: "translate(70.95 63.252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d3424a",
    d: "M0 16.004.032-.001h.353L.353 16.006z",
    "data-name": "Rectangle 2903"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M81.125 61.906h13.221v1.346H81.125z",
    "data-name": "Rectangle 2905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M81.125 65.156h10.582v.673H81.125z",
    "data-name": "Rectangle 2906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M81.125 66.969h6.909v.673h-6.909z",
    "data-name": "Rectangle 2907"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M89.069 66.969h6.909v.673h-6.909z",
    "data-name": "Rectangle 2908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M92.786 65.156h6.382v.673h-6.382z",
    "data-name": "Rectangle 2909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M95.137 61.906h6.136v1.346h-6.136z",
    "data-name": "Rectangle 2910"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M62.337 83.722h10.559v1.075H62.337z",
    "data-name": "Rectangle 2911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M62.337 86.318h8.452v.538h-8.452z",
    "data-name": "Rectangle 2912"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M62.337 87.766h5.518v.538h-5.518z",
    "data-name": "Rectangle 2913"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M68.682 87.766H74.2v.538h-5.518z",
    "data-name": "Rectangle 2914"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M71.651 86.318h5.098v.538h-5.098z",
    "data-name": "Rectangle 2915"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M73.529 83.722h4.9v1.075h-4.9z",
    "data-name": "Rectangle 2916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.416 71.426a.8.8 0 1 1-1.128.007.8.8 0 0 1 1.128-.007",
    "data-name": "Path 15660"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.224 74.784a.887.887 0 1 1-1.255.008.887.887 0 0 1 1.255-.008",
    "data-name": "Path 15661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87.283 73.019a.757.757 0 1 1-1.071.006.757.757 0 0 1 1.071-.006",
    "data-name": "Path 15662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.701 75.072a.757.757 0 1 1-1.071.006.757.757 0 0 1 1.071-.006",
    "data-name": "Path 15663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m83.136 75.553 3.613-2.071 3.837 1.852 3.221-3.386.1.093-3.289 3.457-3.862-1.863-3.552 2.034Z",
    "data-name": "Path 15664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.315 76.713a.661.661 0 1 1 .921-.16.66.66 0 0 1-.921.16",
    "data-name": "Path 15665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.466 73.531a.735.735 0 1 1 1.025-.178.735.735 0 0 1-1.025.178",
    "data-name": "Path 15666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.928 74.435a.628.628 0 1 1 .875-.152.63.63 0 0 1-.875.152",
    "data-name": "Path 15667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104.576 72.266a.628.628 0 1 1 .875-.152.63.63 0 0 1-.875.152",
    "data-name": "Path 15668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m104.974 71.796-2.671 2.187-3.391-.989-2.17 3.209-.093-.063 2.216-3.276 3.412 1 2.625-2.15Z",
    "data-name": "Path 15669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m89.345 87.568-.77-4.045-.336 1.728H83.7v-.273h4.315l.564-2.9.805 4.23.362-1.428h.784l.535-2.49.685 3.8.36-1.454h1.619l.6-1.954.521 3.421.419-1.467h1.34l.393-2.146.846 3.375.306-1.23h1.733l.091 1.025.954-3.731.627 2.716h2.818v.273h-3.035l-.423-1.833-1.072 4.191-.21-2.368h-1.269l-.519 2.084-.8-3.213-.207 1.129H95.47l-.706 2.474-.529-3.472-.3 1h-1.608l-.616 2.488-.666-3.694-.291 1.353h-.792Z",
    "data-name": "Path 15670"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.641 90.229h-23.3v-9.87h23.3Zm-23.154-.155h23v-9.569h-23Z",
    "data-name": "Path 15671"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M187.379 166.62H42.435c-.1 0-.181-.109-.181-.241v-.138c0-.133.081-.241.181-.241h144.944c.1 0 .181.109.181.241v.138c0 .133-.081.241-.181.241",
    "data-name": "Path 15672"
  }))))))));
};
export default SvgSensory;